// extracted by mini-css-extract-plugin
export default {"root":"SABtnX","alignmentWrapper":"cfG0b3"};